import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgPeopleSpeak = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M10.75 4a4.3 4.3 0 1 0 0 8.6 4.3 4.3 0 0 0 0-8.6Zm0 2a2.3 2.3 0 1 1 0 4.6 2.3 2.3 0 0 1 0-4.6ZM10.75 13.075a8.425 8.425 0 0 1 8.425 8.425 1 1 0 0 1-2 0 6.425 6.425 0 0 0-12.85 0 1 1 0 0 1-2 0 8.425 8.425 0 0 1 8.425-8.425ZM17.053 5.106a1 1 0 0 1 1.341.447c.09.177.205.467.317.856.433 1.507.433 3.214-.285 4.97a1 1 0 0 1-1.852-.758c.532-1.3.532-2.555.215-3.66l-.038-.124-.069-.205-.055-.14-.021-.045a1 1 0 0 1 .447-1.341ZM20.514 3.126a1 1 0 0 1 1.36.388c.156.28.37.76.579 1.415.82 2.57.82 5.487-.543 8.485a1 1 0 0 1-1.82-.828c1.137-2.502 1.137-4.918.457-7.049a8.603 8.603 0 0 0-.237-.657l-.102-.231a2.75 2.75 0 0 0-.082-.163 1 1 0 0 1 .388-1.36Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgPeopleSpeak)
const Memo = memo(ForwardRef)
export default Memo
